import dayjs from "dayjs";
import { set } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  NOTIFICATION_COUNT,
  NOTIFICATION_LIST,
  NOTIFICATION_READ,
  NOTIFICATION_READ_ALL,
} from "../commons/constants/api-urls";
import { routerNavigation } from "../commons/constants/routers";
import defaultAxios from "../commons/utils/axios";
import { MerchantNotificationEventName, STATUS_CODE } from "../components/Notification/Notification";
import useDataTable from "./useDataTable";

const useTencentNotifications = (user: Partial<User> | null) => {
  const navigate = useNavigate();

  const { dataSrc, setDataSrc, fetchData, params, onChangeTable, metadata, loading } =
    useDataTable(getListNotifications);

  const [unreadNotifications, setUnreadNotifications] = useState(0);

  function mapTencentNotificationsToBENotifications(notifications: TencentNotificationMessage) {
    const objectNotifications: TridentFoodNotifications = JSON.parse(notifications.payload.text);
    return objectNotifications;
  }

  async function handlePushNotificationsRecieved(notifications: TencentNotificationMessage) {
    const formatedNotifications: TridentFoodNotifications = mapTencentNotificationsToBENotifications(notifications);
    await handleUpdateUnreadNotifications();
    setDataSrc(prev => {
      prev.pop();
      return [formatedNotifications, ...prev];
    });
  }

  async function handleUpdateUnreadNotifications() {
    try {
      const res = await defaultAxios.get(NOTIFICATION_COUNT);
      if (res.data?.unread >= 0 && res.status === STATUS_CODE.SUCCESS) {
        setUnreadNotifications(res.data?.unread);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getListNotifications(params: any) {
    try {
      const res = await defaultAxios.get(NOTIFICATION_LIST, { params });
      return res;
    } catch (error) {
      console.log(error);
    }
  }

  const redirectRoute = (item: any) => {
    const path = item?.meta?.eventName;
    const storeId = item?.meta?.storeId;
    const productId = item?.meta?.productId;
    const voucherId = item?.meta?.voucherId;
    const campaignId = item?.meta?.campaignId;
    if (path === MerchantNotificationEventName.MBSUpgraded) {
      navigate(routerNavigation.LP_MEMBER_SHIP.MEMBERSHIP);
    } else if (path === MerchantNotificationEventName.RefundCreated) {
      navigate(routerNavigation.STORES.REFUND_MANAGEMENT(storeId));
    } else if (path === MerchantNotificationEventName.BadgePublished) {
      navigate(routerNavigation.STORES.BADGE_MANAGEMENT(storeId));
    } else if (path === MerchantNotificationEventName.LPReceived || path === MerchantNotificationEventName.LPSpent) {
      navigate(routerNavigation.LP_MEMBER_SHIP.LOYALTY_POINTS);
    } else if (path === MerchantNotificationEventName.MerchantAccountDeactivated) {
      navigate(routerNavigation.MERCHANT_MEMBER);
    } else if (
      path === MerchantNotificationEventName.MerchantStoreCreated ||
      path === MerchantNotificationEventName.MerchantStoreUpdated
    ) {
      navigate(routerNavigation.STORES.STORE_DASHBOARD(storeId));
    } else if (
      path === MerchantNotificationEventName.ProductCreatedApproval ||
      path === MerchantNotificationEventName.ProductEditApproval ||
      path === MerchantNotificationEventName.ProductCloned
    ) {
      navigate(routerNavigation.STORES.UPDATE_PRODUCT(storeId, productId));
    } else if (
      path === MerchantNotificationEventName.VoucherActivated ||
      path === MerchantNotificationEventName.VoucherDeactivated
    ) {
      navigate(routerNavigation.STORES.VOUCHER_DETAIL(storeId, voucherId));
    } else if (
      path === MerchantNotificationEventName.CampaignRunning ||
      path === MerchantNotificationEventName.CampaignUpdated ||
      path === MerchantNotificationEventName.CampaignStopped
    ) {
      navigate(routerNavigation.LP_MEMBER_SHIP.CAMPAIGN_DETAIL(campaignId));
    } else {
      navigate(routerNavigation.STORES.PRODUCT_MANAGEMENT(storeId));
    }
  };

  const handleReadNotification = async (item: any) => {
    try {
      if (!dayjs(item.read_at).isValid()) {
        setDataSrc(prev => {
          const cloneArr = [...prev];
          const index = prev.findIndex(i => i.id === item.id);
          if (index === -1) {
            return prev;
          } else {
            set(item, "read_at", dayjs().toString());
            cloneArr[index] = item;
            return cloneArr;
          }
        });

        setUnreadNotifications(prev => prev - 1);
        console.log("Read success");
        await defaultAxios.put(NOTIFICATION_READ(item.id));
      }
      redirectRoute(item);
    } catch (error) {
      console.log(error);
    }
  };

  const handleReadAllNotifications = async () => {
    try {
      setDataSrc(prev => {
        const cloneArr = [...prev];
        cloneArr.forEach(item => {
          set(item, "read_at", dayjs().toString());
        });
        return cloneArr;
      });
      setUnreadNotifications(0);
      await defaultAxios.put(NOTIFICATION_READ_ALL);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData(params);
    handleUpdateUnreadNotifications();
  }, [params, user]);

  useEffect(() => {
    if (!user) {
      console.log("log out");
      setDataSrc([]);
    }
  }, [user]);

  return {
    notifications: dataSrc,
    handlePushNotificationsRecieved,
    onChangeTableNotifications: onChangeTable,
    metadataNotifications: metadata,
    loadingNotifications: loading,
    handleReadNotification,
    handleUpdateUnreadNotifications,
    unreadNotifications,
    handleReadAllNotifications,
  };
};

export default useTencentNotifications;
